export const DEFAULT_SORT_KEY = 'name';
export const DEFAULT_STATUS = 'active';

export const STATUS_OPTIONS = [
  {value: 'active', label: 'statusActive'},
  {value: 'deleted', label: 'statusDeleted'},
  {value: 'all', label: 'statusAll'}
];

const ASC = 1;
const DESC = -1;

export const SORT_OPTIONS = [
  {key: 'name', label: 'sortTenantAz', dir: ASC},
  {key: 'plan', label: 'colPlan', dir: ASC},
  {key: 'progress', label: 'colCreationStatus', dir: ASC},
  {key: 'transaction_errors', label: 'colTransactionErrors', dir: DESC},
  {key: 'shipped_last', label: 'colShippedLastMonth', dir: DESC},
  {key: 'average_shipped_last', label: 'colAvgShippedLastMonth', dir: DESC},
  {key: 'total_shipped', label: 'colShippedThisMonth', dir: DESC},
  {key: 'average_shipped', label: 'colAvgShippedThisMonth', dir: DESC},
  {key: 'max_allowed', label: 'colPlanMax', dir: DESC},
  {key: 'regular_users_count', label: 'sortRegularUsers', dir: DESC},
  {key: 'admin_only_users_count', label: 'sortAdminOnlyUsers', dir: DESC},
  {key: 'last_activity', label: 'colLastActivity', dir: DESC},
  {key: 'last_import_store_type', label: 'colLastImportStoreType', dir: ASC},
  {key: 'is_deleted', label: 'colAccountStatus', dir: ASC}
];

export const sortInfoFor = key => {
  const option = SORT_OPTIONS.find(candidate => candidate.key === key);
  return {name: option.key, dir: option.dir};
};

export const DEFAULT_FILTERS = {
  status: DEFAULT_STATUS,
  sortKey: DEFAULT_SORT_KEY,
  allSorting: false
};

export const activeFilterCount = ({status, sortKey, allSorting}) =>
  Number(status !== DEFAULT_STATUS) +
  Number(sortKey !== DEFAULT_SORT_KEY) +
  Number(allSorting);
